export default (function (amount) {
  var amountDecimal = Number(amount).toFixed(2);
  var sign = '$';
  return "".concat(sign).concat(amountDecimal);
});
//# sourceMappingURL=formatCurrency.js.map